import { updateBeginWorkStep } from 'src/providers/UpdateBeginWorkStepsProvider';
import { BEGIN_WORK_STEPS_IDS } from 'src/constants/beginWorksSteps';

import useGoTo from 'src/hooks/useGoTo';
import { ROUTES_URL } from 'src/constants/routes';

import ChatsAndChannelsContent from '../ChatsAndChannels/Content';

import type { IBeginWorkOnSuccessArgs } from 'src/types';

export default function ChatsAndChannels() {
    const goTo = useGoTo();

    const onSuccessHandler = (_params?: IBeginWorkOnSuccessArgs) => {
        // Обновляем шаг на ADD_CHATS, затем переходим на страницу оплаты
        updateBeginWorkStep({
            currentStep: BEGIN_WORK_STEPS_IDS.ADD_CHATS,
            onSuccess: () => {
                // Переходим на страницу оплаты
                goTo(ROUTES_URL.PAYMENT);
            },
        });
    };

    return (
        <ChatsAndChannelsContent
            onSuccess={onSuccessHandler}
            isOnboarding
        />
    );
}
